export const LOCAL_STORAGE_KEY = 'cookie_consent';

declare global {
    interface Window {
        dataLayer: any;
        gtag: any;
    }
}

export interface IGdpr{
    accept: boolean,
}

export const setGdpr = (data: IGdpr) => {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, encodeURIComponent(JSON.stringify(data)));
};

export const getGdpr = () : IGdpr|null => {
    const ls = window.localStorage.getItem(LOCAL_STORAGE_KEY);
    if(!ls) return null;

    let data = null;

    try{
        data = JSON.parse(decodeURIComponent(ls));
    }
    catch (ex){}

    return data;
};

export const startGoogleAnalytics = () => {
    const $script = document.createElement('script');
    $script.type = 'text/javascript';
    $script.setAttribute('async', 'true');
    $script.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-Z5T4DW77R');

    document!.documentElement!.firstChild!.appendChild($script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
        window.dataLayer.push(arguments)
    };
    window.gtag('js', new Date());
    window.gtag('config', 'G-Z5T4DW77RE');
};